import { ColumnType } from '../util/types'

export const knivesColumns: ColumnType[] = [
  // 编号
  {
    label: 'sideHoleMachine.knifes.number',
    props: 'id',
    canEdit: false,
    width: 90,
    align: 'center',
  },
  // 刀宽
  {
    label: 'sideHoleMachine.knifes.diameter',
    props: 'diameter',
    canEdit: true,
    width: 90,
    isInputCheck: true,
    align: 'center',
  },
  // 类型
  {
    label: 'sideHoleMachine.knifes.type',
    props: 'type',
    canEdit: true,
    align: 'center',
  },
  // 快速进给速度
  {
    label: 'sideHoleMachine.knifes.moveSpeed',
    props: 'moveSpeed',
    canEdit: true,
    isInputCheck: true,
    align: 'center',
  },
  // 加工速度
  {
    label: 'sideHoleMachine.knifes.doSpeed',
    props: 'doSpeed',
    canEdit: true,
    isInputCheck: true,
    align: 'center',
  },
  // 换刀开始代码
  {
    label: 'sideHoleMachine.knifes.startCode',
    props: 'startCode',
    canEdit: true,
    isTextarea: true,
    align: 'center',
  },
  // 换刀结束代码
  {
    label: 'sideHoleMachine.knifes.endCode',
    props: 'endCode',
    canEdit: true,
    isTextarea: true,
    align: 'center',
  },
]

export const codeList = [
  // 设备启动代码
  {
    title: 'sideHoleMachine.equipmentParams.equipStartCode',
    key: 'beginCode',
    elementId: 'span_0qijqqzu1p',
  },
  // 设备暂停代码
  {
    title: 'sideHoleMachine.equipmentParams.equipPauseCode',
    key: 'pauseCode',
    elementId: 'span_78elyffdlj',
  },
  // 设备结束代码
  {
    title: 'sideHoleMachine.equipmentParams.equipEndCode',
    key: 'endCode',
    elementId: 'span_sn3v9lr2mj',
  },
  // 左面开始代码
  {
    title: 'sideHoleMachine.equipmentParams.leftTurnCode',
    key: 'leftTurnCode',
    elementId: 'span_6p5822sud1',
  },
  // 左面结束代码
  {
    title: 'sideHoleMachine.equipmentParams.leftTurnEndCode',
    key: 'leftTurnEndCode',
    elementId: 'span_45w45v3ej4',
  },
  // 下面开始代码
  {
    title: 'sideHoleMachine.equipmentParams.downTurnCode',
    key: 'backTurnCode',
    elementId: 'span_6p5822sud1',
  },
  // 下面结束代码
  {
    title: 'sideHoleMachine.equipmentParams.downTurnEndCode',
    key: 'backTurnEndCode',
    elementId: 'span_ca1h50wup8',
  },
  // 右面开始代码
  {
    title: 'sideHoleMachine.equipmentParams.rightTurnCode',
    key: 'rightTurnCode',
    elementId: 'span_6p5822sud1',
  },
  // 右面结束代码
  {
    title: 'sideHoleMachine.equipmentParams.rightTurnEndCode',
    key: 'rightTurnEndCode',
    elementId: 'span_ca1h50wup8',
  },
  // 上面开始代码
  {
    title: 'sideHoleMachine.equipmentParams.frontTurnCode',
    key: 'frontTurnCode',
    elementId: 'span_6p5822sud1',
  },
  // 上面结束代码
  {
    title: 'sideHoleMachine.equipmentParams.frontTurnEndCode',
    key: 'frontTurnEndCode',
    elementId: 'span_ca1h50wup8',
  },
]

export const holeSetting = [
  // 移动代码
  {
    title: 'sideHoleMachine.equipmentParams.moveCode',
    key: 'holeMove',
    elementId: 'span_fm6gztpxnj',
  },
  // 加工代码
  {
    title: 'sideHoleMachine.equipmentParams.punchCode',
    key: 'punchHole',
    elementId: 'span_bgix4mmnji',
  },
  // 摆动代码
  {
    title: 'sideHoleMachine.equipmentParams.wiggleCode',
    key: 'swingCode',
    elementId: 'span_dpg4t0dkj9',
  },
  // 气缸收回指令
  {
    title: 'sideHoleMachine.equipmentParams.cylinderbackDirective',
    key: 'holeStop',
    elementId: 'span_rbaylgj8j2',
  },
]
export const slotSetting = [
  // 空走
  {
    title: 'sideHoleMachine.equipmentParams.free',
    key: 'freeSlot',
    elementId: 'span_si31gwa4ej',
  },
  // 加工部分
  {
    title: 'sideHoleMachine.equipmentParams.punchPart',
    key: 'punchSlot',
    elementId: 'span_x4lmc4cvjf',
  },
  // 加工平面代码
  {
    title: 'sideHoleMachine.equipmentParams.cutFaceCode',
    key: 'cutFace',
    elementId: 'span_58rewnoqbp',
  },
  // 气缸收回指令
  {
    title: 'sideHoleMachine.equipmentParams.cylinderbackDirective',
    key: 'stopCode',
    elementId: 'span_dpg4t0dkj9',
  },
]
